import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUplabsComponent } from './simple-icons-uplabs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUplabsComponent ],
    exports:      [ SimpleIconsUplabsComponent ],
    bootstrap:    []
})
export class SimpleIconsUplabsModule {}
